// // src/pages/CourseDetailPage.jsx
// import { useEffect } from "react";
// import { useParams, Link, useNavigate } from "react-router-dom";
// import { Helmet } from "react-helmet-async";
// import { useSelector } from "react-redux";
// import { toast } from "sonner";
// import DOMPurify from "dompurify";
// import parse from "html-react-parser";

// import {
//   useGetCourseBySlugQuery,
//   useGetCourseProgressQuery,
//   useEnrollCourseMutation,
// } from "@/features/api/courseApi";

// import { useGetOrdersQuery } from "@/features/api/paymentApi";

// import {
//   BookOpen,
//   Video as VideoIcon,
//   Clock,
//   BarChart,
//   Languages,
//   ListVideo,
//   ChevronRight,
//   GraduationCap,
// } from "lucide-react";

// import { Button } from "@/components/ui/button";
// import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
// import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
// import { Separator } from "@/components/ui/separator";
// import { Skeleton } from "@/components/ui/skeleton";
// import { Progress } from "@/components/ui/progress";

// import {
//   Breadcrumb,
//   BreadcrumbItem,
//   BreadcrumbLink,
//   BreadcrumbList,
//   BreadcrumbSeparator,
// } from "@/components/ui/breadcrumb";

// export default function CourseDetailPage() {
//   const { slug } = useParams();
//   const navigate = useNavigate();
//   const user = useSelector((state) => state.auth?.user);

//   const { data, isLoading, error, refetch } = useGetCourseBySlugQuery(slug, { skip: !slug });
//   const course = data?.course;

//   const {
//     data: progressData,
//     isLoading: progressLoading,
//     error: progressError,
//   } = useGetCourseProgressQuery(course?._id, { skip: !course?._id || !user })


//   const { data: ordersData, isLoading: ordersLoading } = useGetOrdersQuery(
//     { search: user?.email },
//     { skip: !user?.email }
//   );

//   const [enrollCourse, { isLoading: enrolling }] = useEnrollCourseMutation();

//   useEffect(() => {
//     if (error) toast.error("❌ Failed to load course.");
//     if (progressError) toast.error("❌ Failed to load progress.");
//   }, [error, progressError]);

//   useEffect(() => {
//     if (!refetch) return;
//     const interval = setInterval(() => refetch(), 30000);
//     return () => clearInterval(interval);
//   }, [refetch]);

//   if (isLoading || !course) {
//     return (
//       <div className="container px-4 py-8 mx-auto">
//         <Skeleton className="h-64 w-full rounded-md" />
//         <div className="grid lg:grid-cols-3 gap-8 mt-6">
//           <div className="lg:col-span-2 space-y-4">
//             <Skeleton className="h-6 w-3/4" />
//             <Skeleton className="h-4 w-1/2" />
//             <Skeleton className="h-40 w-full" />
//           </div>
//           <div>
//             <Skeleton className="h-48 w-full" />
//           </div>
//         </div>
//       </div>
//     );
//   }

//   const isEnrolledFromProfile = !!user?.enrolledCourses?.includes(course._id);
//   const isEnrolledFromOrders = !!(
//     ordersData?.data &&
//     ordersData.data.some(
//       (order) =>
//         (order.courseId === course._id || order.productId === course._id) &&
//         order.status === "SUCCESS" &&
//         (order.email === user?.email || order.customerEmail === user?.email)
//     )
//   );
//   const isEnrolled = isEnrolledFromProfile || isEnrolledFromOrders;

//   let buttonText = `Buy Now ₹${course.price || 0}`;
//   if (isEnrolled) {
//     if (progressLoading) buttonText = "Loading...";
//     else if (progressData?.completed) buttonText = "Completed";
//     else if (progressData?.started) buttonText = "Continue";
//     else buttonText = "Start Now";
//   } else if (!course.price || course.price === 0) {
//     buttonText = "Enroll Now";
//   }

//   const sanitizedHtml = typeof course.content === "string" ? DOMPurify.sanitize(course.content) : "";
//   // const sanitizedFaqs = typeof course.faqs === "string" ? DOMPurify.sanitize(course.faqs) : "";
//   // const requirements = course.requirements?.split(",").map((r) => r.trim()) || [];

//   const instructorInitials =
//     course.instructorName?.split(" ").map((n) => n[0]).join("") || "IN";

//   const handleBuyNow = () => {
//     if (!user) {
//       toast.error("Please login to buy this course.");
//       navigate("/login");
//       return;
//     }
//     const query = new URLSearchParams({
//       courseId: course._id,
//       courseName: course.title,
//       price: (course.price || 0).toString(),
//       courseImage:
//         typeof course.featuredImage === "string"
//           ? course.featuredImage
//           : course.featuredImage?.url || "",
//     }).toString();
//     navigate(`/checkout?${query}`);
//   };

//   const handleCourseAction = async () => {
//     if (!user) {
//       toast.error("Please login to continue.");
//       navigate("/login");
//       return;
//     }

//     if (isEnrolled) {
//       navigate(`/courses/${course.slug}/learn`);
//       return;
//     }

//     if (!course.price || course.price === 0) {
//       try {
//         const res = await enrollCourse({ courseId: course._id }).unwrap();
//         toast.success(res?.message || "Enrolled successfully!");
//         navigate(`/courses/${course.slug}/learn`);
//       } catch (err) {
//         toast.error(err?.data?.message || "Failed to enroll");
//       }
//     } else {
//       handleBuyNow();
//     }
//   };

//   const progress = progressData?.percentage || 0;

//   const renderHtmlContent = (html) => {
//     try {
//       return html ? parse(html) : <p>No content available.</p>;
//     } catch {
//       return <p>Error rendering content.</p>;
//     }
//   };

//   const hasVideo =
//     Boolean(course.videoUrl) ||
//     Boolean(course.videoFile?.url || course.videoFile?.path);

//   const videoSrc = course.videoUrl || course.videoFile?.url || course.videoFile?.path;

//   const hasImage =
//     Boolean(course.featuredImage) &&
//     (typeof course.featuredImage === "string"
//       ? course.featuredImage
//       : course.featuredImage?.url);

//   return (
//     <div className="bg-background min-h-screen">
//       <Helmet>
//         <title>{course.title}</title>
//         <meta name="description" content={course.metaDescription || course.title} />
//       </Helmet>

//       <div className="container px-4 py-8 mx-auto">
//         <Breadcrumb className="mb-6">
//           <BreadcrumbList>
//             <BreadcrumbItem>
//               <BreadcrumbLink asChild>
//                 <Link to="/">Home</Link>
//               </BreadcrumbLink>
//             </BreadcrumbItem>
//             <BreadcrumbSeparator />
//             <BreadcrumbItem>
//               <span>{course.title}</span>
//             </BreadcrumbItem>
//           </BreadcrumbList>
//         </Breadcrumb>

//         <div className="grid lg:grid-cols-3 gap-8 items-start">
//           <div className="lg:col-span-2 space-y-8">
//             <header className="space-y-4">
//               <h1 className="text-3xl md:text-4xl font-bold">{course.title}</h1>
//               <p className="text-muted-foreground text-lg">{course.metaDescription}</p>

//               <div className="flex items-center gap-4">
//                 <Avatar>
//                   <AvatarImage src={course.instructorAvatar} />
//                   <AvatarFallback>{instructorInitials}</AvatarFallback>
//                 </Avatar>
//                 <div>
//                   <p className="font-semibold">{course.instructorName}</p>
//                   <p className="text-sm text-muted-foreground">{course.instructorBio}</p>
//                 </div>
//               </div>
//             </header>

//             {/* MEDIA BLOCK */}
//             {hasVideo ? (
//               <div className="w-full aspect-video rounded-md overflow-hidden bg-black shadow">
//                 <video controls src={videoSrc} className="w-full h-full object-cover"></video>
//               </div>
//             ) : hasImage ? (
//               <div className="w-full aspect-video rounded-md overflow-hidden shadow bg-muted">
//                 <img
//                   src={
//                     typeof course.featuredImage === "string"
//                       ? course.featuredImage
//                       : course.featuredImage?.url
//                   }
//                   alt={course.title}
//                   className="w-full h-full object-cover"
//                 />
//               </div>
//             ) : null}

//             {/* ✅ MOBILE ENROLL CARD (below image) */}
//             <div className="lg:hidden">
//               <Card>
//                 <CardHeader>
//                   <p className="text-4xl font-bold">
//                     {course.price ? `₹${course.price}` : "Free"}
//                   </p>
//                 </CardHeader>

//                 <CardContent className="space-y-4">
//                   <Button
//                     size="lg"
//                     className="w-full"
//                     onClick={handleCourseAction}
//                     disabled={enrolling}
//                   >
//                     <BookOpen className="mr-2" />
//                     {enrolling ? "Enrolling..." : buttonText}
//                   </Button>

//                   {isEnrolled && (
//                     <>
//                       <Progress value={progress} className="h-2" />
//                       <p className="text-sm text-muted-foreground">{progress}% completed</p>
//                     </>
//                   )}

//                   <Separator />

//                   <div className="space-y-2 text-sm">
//                     <div className="flex items-center gap-2">
//                       <Clock className="h-4 w-4" /> {course.duration}
//                     </div>
//                     <div className="flex items-center gap-2">
//                       <BarChart className="h-4 w-4" /> {course.level}
//                     </div>
//                     <div className="flex items-center gap-2">
//                       <ListVideo className="h-4 w-4" /> {course.lessons?.length} lessons
//                     </div>
//                     <div className="flex items-center gap-2">
//                       <Languages className="h-4 w-4" /> {course.language}
//                     </div>
//                     <div className="flex items-center gap-2">
//                       <GraduationCap className="h-4 w-4" />{" "}
//                       {course.certificate ? "Certificate included" : "No certificate"}
//                     </div>
//                   </div>
//                 </CardContent>
//               </Card>
//             </div>

//             {/* LESSONS */}
//             <Card>
//               <CardHeader>
//                 <CardTitle>Course Lessons</CardTitle>
//               </CardHeader>
//               <CardContent>
//                 {course.lessons?.length ? (
//                   <ul className="space-y-3">
//                     {course.lessons.map((lesson, i) => (
//                       <li
//                         key={i}
//                         className="flex items-center justify-between p-3 border rounded-lg"
//                       >
//                         <div className="flex items-center gap-3">
//                           <div className="h-8 w-8 flex items-center justify-center bg-primary/10 rounded-full font-semibold text-primary">
//                             {i + 1}
//                           </div>
//                           <div>
//                             <p className="font-medium">{lesson.title}</p>
//                             <p className="text-xs text-muted-foreground">{lesson.duration}</p>
//                           </div>
//                         </div>
//                         {lesson.videoUrl ? (
//                           <a
//                             href={lesson.videoUrl}
//                             target="_blank"
//                             rel="noreferrer"
//                             className="text-primary text-sm flex items-center gap-1"
//                           >
//                             <VideoIcon className="w-4 h-4" /> Watch
//                           </a>
//                         ) : (
//                           <ChevronRight className="text-muted-foreground" />
//                         )}
//                       </li>
//                     ))}
//                   </ul>
//                 ) : (
//                   <p>No lessons available.</p>
//                 )}
//               </CardContent>
//             </Card>

//             {/* ABOUT */}
//             <Card>
//               <CardHeader>
//                 <CardTitle>About this course</CardTitle>
//               </CardHeader>
//               <CardContent>
//                 <div className="prose max-w-none">{renderHtmlContent(sanitizedHtml)}</div>
//               </CardContent>
//             </Card>

//             {/* REQUIREMENTS
//             {requirements.length > 0 && (
//               <Card>
//                 <CardHeader>
//                   <CardTitle>Requirements</CardTitle>
//                 </CardHeader>
//                 <CardContent>
//                   <ul className="list-disc list-inside space-y-2">
//                     {requirements.map((req, i) => (
//                       <li key={i}>{req}</li>
//                     ))}
//                   </ul>
//                 </CardContent>
//               </Card>
//             )} */}

//             {/* FAQ
//             <Card>
//               <CardHeader>
//                 <CardTitle>FAQs</CardTitle>
//               </CardHeader>
//               <CardContent>{renderHtmlContent(sanitizedFaqs)}</CardContent>
//             </Card> */}
//           </div>

//           {/* DESKTOP SIDEBAR */}
//           <aside className="hidden lg:block">
//             <div className="sticky top-6">
//               <Card>
//                 <CardHeader>
//                   <p className="text-4xl font-bold">
//                     {course.price ? `₹${course.price}` : "Free"}
//                   </p>
//                 </CardHeader>
//                 <CardContent className="space-y-4">
//                   <Button
//                     size="lg"
//                     className="w-full"
//                     onClick={handleCourseAction}
//                     disabled={enrolling}
//                   >
//                     <BookOpen className="mr-2" />
//                     {enrolling ? "Enrolling..." : buttonText}
//                   </Button>

//                   {isEnrolled && (
//                     <>
//                       <Progress value={progress} className="h-2" />
//                       <p className="text-sm text-muted-foreground">{progress}% completed</p>
//                     </>
//                   )}

//                   <Separator />

//                   <div className="space-y-2 text-sm">
//                     <div className="flex items-center gap-2">
//                       <Clock className="h-4 w-4" /> {course.duration}
//                     </div>
//                     <div className="flex items-center gap-2">
//                       <BarChart className="h-4 w-4" /> {course.level}
//                     </div>
//                     <div className="flex items-center gap-2">
//                       <ListVideo className="h-4 w-4" /> {course.lessons?.length} lessons
//                     </div>
//                     <div className="flex items-center gap-2">
//                       <Languages className="h-4 w-4" /> {course.language}
//                     </div>
//                     <div className="flex items-center gap-2">
//                       <GraduationCap className="h-4 w-4" />{" "}
//                       {course.certificate ? "Certificate included" : "No certificate"}
//                     </div>
//                   </div>
//                 </CardContent>
//               </Card>
//             </div>
//           </aside>
//         </div>
//       </div>
//     </div>
//   );
// }








// "use client";

// import { useEffect } from "react";
// import { useParams, Link, useNavigate } from "react-router-dom";
// import { Helmet } from "react-helmet-async";
// import { useSelector } from "react-redux";
// import { toast } from "sonner";
// import DOMPurify from "dompurify";
// import parse from "html-react-parser";

// import {
//   useGetCourseBySlugQuery,
//   useGetCourseProgressQuery,
//   useEnrollCourseMutation,
// } from "@/features/api/courseApi";

// import { useGetOrdersQuery } from "@/features/api/paymentApi";

// import {
//   BookOpen,
//   Video as VideoIcon,
//   Clock,
//   BarChart,
//   Languages,
//   ListVideo,
//   ChevronRight,
//   GraduationCap,
// } from "lucide-react";

// import { Button } from "@/components/ui/button";
// import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
// import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
// import { Separator } from "@/components/ui/separator";
// import { Skeleton } from "@/components/ui/skeleton";
// import { Progress } from "@/components/ui/progress";

// import {
//   Breadcrumb,
//   BreadcrumbItem,
//   BreadcrumbLink,
//   BreadcrumbList,
//   BreadcrumbSeparator,
// } from "@/components/ui/breadcrumb";

// export default function CourseDetailPage() {
//   const { slug } = useParams();
//   const navigate = useNavigate();
//   const user = useSelector((state) => state.auth?.user);

//   /* ----------------------------------------
//    Normalize local /uploads media paths
//   ---------------------------------------- */
//   const normalizeMedia = (url) => {
//     if (!url) return "";
//     if (url.startsWith("/uploads")) return `https://fetc.in${url}`;
//     return url;
//   };

//   /* ----------------------------------------
//    Fetch course
//   ---------------------------------------- */
//   const { data, isLoading, error, refetch } = useGetCourseBySlugQuery(slug, {
//     skip: !slug,
//   });

//   const course = data?.course;

//   /* ----------------------------------------
//    Fetch progress (only after course loads)
//   ---------------------------------------- */
//   const {
//     data: progressData,
//     isLoading: progressLoading,
//   } = useGetCourseProgressQuery(course?._id, {
//     skip: !course?._id || !user,
//   });

//   /* ----------------------------------------
//    Orders (paid enroll check)
//   ---------------------------------------- */
//   const { data: ordersData } = useGetOrdersQuery(
//     { search: user?.email },
//     { skip: !user?.email }
//   );

//   const [enrollCourse, { isLoading: enrolling }] = useEnrollCourseMutation();

//   /* ----------------------------------------
//    Handle Errors
//   ---------------------------------------- */
//   useEffect(() => {
//     if (error) toast.error("Failed to load course.");
//   }, [error]);

//   /* ----------------------------------------
//    Auto refresh every 30s
//   ---------------------------------------- */
//   useEffect(() => {
//     if (!refetch) return;
//     const interval = setInterval(refetch, 30000);
//     return () => clearInterval(interval);
//   }, [refetch]);

//   /* ----------------------------------------
//    Loading Skeleton
//   ---------------------------------------- */
//   if (isLoading || !course) {
//     return (
//       <div className="container px-4 py-8 mx-auto">
//         <Skeleton className="h-64 w-full rounded-lg" />
//         <div className="grid lg:grid-cols-3 gap-8 mt-6">
//           <div className="lg:col-span-2 space-y-4">
//             <Skeleton className="h-6 w-3/4" />
//             <Skeleton className="h-4 w-1/2" />
//             <Skeleton className="h-40 w-full" />
//           </div>
//           <Skeleton className="h-48 w-full" />
//         </div>
//       </div>
//     );
//   }

//   /* ----------------------------------------
//    Enrollment Logic
//   ---------------------------------------- */
//   const isEnrolledViaProfile = !!user?.enrolledCourses?.includes(course._id);

//   const isEnrolledViaOrders =
//     ordersData?.data?.some(
//       (order) =>
//         (order.courseId === course._id || order.productId === course._id) &&
//         order.status === "SUCCESS" &&
//         (order.email === user?.email || order.customerEmail === user?.email)
//     ) || false;

//   const isEnrolled = isEnrolledViaProfile || isEnrolledViaOrders;

//   /* ----------------------------------------
//    Enrollment Button Label
//   ---------------------------------------- */
//   let buttonText = `Buy Now ₹${course.price || 0}`;

//   if (isEnrolled) {
//     if (progressLoading) buttonText = "Loading...";
//     else if (progressData?.isCompleted) buttonText = "Completed";
//     else if (progressData?.percentage > 0) buttonText = "Continue Learning";
//     else buttonText = "Start Course";
//   } else if (!course.price || course.price === 0) {
//     buttonText = "Enroll for Free";
//   }

//   /* ----------------------------------------
//    Content sanitization
//   ---------------------------------------- */
//   const sanitizedHtml = DOMPurify.sanitize(course.content || "");

//   const instructorInitials =
//     course.instructorName
//       ?.split(" ")
//       .map((n) => n[0])
//       .join("") || "IN";

//   /* ----------------------------------------
//    Enrollment Handler
//   ---------------------------------------- */
//   const handleCourseAction = async () => {
//     if (!user) {
//       toast.error("Please login to continue.");
//       return navigate("/login");
//     }

//     // Already enrolled → open learning page
//     if (isEnrolled) return navigate(`/courses/${course.slug}/learn`);

//     // Free course → enroll immediately
//     if (!course.price || course.price == 0) {
//       try {
//         const res = await enrollCourse({ courseId: course._id }).unwrap();
//         toast.success(res?.message || "Enrolled!");
//         return navigate(`/courses/${course.slug}/learn`);
//       } catch (err) {
//         return toast.error(err?.data?.message || "Enrollment failed");
//       }
//     }

//     // Paid course → checkout
//     navigate(
//       `/checkout?${new URLSearchParams({
//         courseId: course._id,
//         price: course.price,
//         courseName: course.title,
//         courseImage: course.featuredImage,
//       }).toString()}`
//     );
//   };

//   const progressPercent = progressData?.percentage || 0;

//   /* ----------------------------------------
//    Normalize Media URLs
//   ---------------------------------------- */
//   const videoSrc = normalizeMedia(course.videoUrl);
//   const imageSrc = normalizeMedia(course.featuredImage);

//   /* ----------------------------------------
//    PAGE UI
//   ---------------------------------------- */
//   return (
//     <div className="bg-background min-h-screen">
//       <Helmet>
//         <title>{course.title}</title>
//         <meta name="description" content={course.metaDescription} />
//       </Helmet>

//       <div className="container px-4 py-8 mx-auto">

//         {/* Breadcrumb */}
//         <Breadcrumb className="mb-6">
//           <BreadcrumbList>
//             <BreadcrumbItem>
//               <BreadcrumbLink asChild>
//                 <Link to="/">Home</Link>
//               </BreadcrumbLink>
//             </BreadcrumbItem>
//             <BreadcrumbSeparator />
//             <BreadcrumbItem>{course.title}</BreadcrumbItem>
//           </BreadcrumbList>
//         </Breadcrumb>

//         <div className="grid lg:grid-cols-3 gap-8 items-start">

//           {/* LEFT — course content */}
//           <div className="lg:col-span-2 space-y-8">

//             {/* Header */}
//             <header className="space-y-4">
//               <h1 className="text-4xl font-bold">{course.title}</h1>

//               <p className="text-lg text-muted-foreground">
//                 {course.metaDescription}
//               </p>

//               <div className="flex items-center gap-4">
//                 <Avatar>
//                   <AvatarImage src={normalizeMedia(course.instructorImage)} />
//                   <AvatarFallback>{instructorInitials}</AvatarFallback>
//                 </Avatar>

//                 <div>
//                   <p className="font-semibold">{course.instructorName}</p>
//                   <p className="text-sm text-muted-foreground">
//                     {course.instructorBio}
//                   </p>
//                 </div>
//               </div>
//             </header>

//             {/* Media */}
//             {course.videoUrl ? (
//               <div className="w-full aspect-video rounded-xl overflow-hidden shadow bg-black">
//                 <video controls src={videoSrc} className="w-full h-full" />
//               </div>
//             ) : (
//               imageSrc && (
//                 <img
//                   src={imageSrc}
//                   alt={course.title}
//                   className="w-full aspect-video rounded-xl object-cover shadow"
//                 />
//               )
//             )}

//             {/* Lessons */}
//             <Card>
//               <CardHeader>
//                 <CardTitle>Course Lessons</CardTitle>
//               </CardHeader>

//               <CardContent className="space-y-3">
//                 {course.lessons?.length ? (
//                   course.lessons.map((lesson, index) => {
//                     const hasVideo = lesson.videoUrls?.length > 0;
//                     const firstVideo = normalizeMedia(lesson.videoUrls?.[0]);

//                     return (
//                       <div
//                         key={lesson._id}
//                         className="flex items-center justify-between p-3 border rounded-lg hover:bg-muted/50 transition"
//                       >
//                         <div className="flex items-center gap-3">
//                           <div className="h-8 w-8 flex items-center justify-center bg-primary/10 rounded-full text-primary font-semibold">
//                             {index + 1}
//                           </div>
//                           <p className="font-medium">{lesson.title}</p>
//                         </div>

//                         {hasVideo ? (
//                           <a
//                             href={firstVideo}
//                             target="_blank"
//                             rel="noreferrer"
//                             className="text-primary flex items-center gap-1 text-sm"
//                           >
//                             <VideoIcon className="w-4 h-4" />
//                             Watch
//                           </a>
//                         ) : (
//                           <ChevronRight className="text-muted-foreground" />
//                         )}
//                       </div>
//                     );
//                   })
//                 ) : (
//                   <p>No lessons available.</p>
//                 )}
//               </CardContent>
//             </Card>

//             {/* About */}
//             <Card>
//               <CardHeader>
//                 <CardTitle>About this Course</CardTitle>
//               </CardHeader>

//               <CardContent>
//                 <div className="prose max-w-none">
//                   {parse(sanitizedHtml)}
//                 </div>
//               </CardContent>
//             </Card>
//           </div>

//           {/* RIGHT — Sidebar */}
//           <aside className="hidden lg:block">
//             <div className="sticky top-6">
//               <Card>
//                 <CardHeader>
//                   <p className="text-4xl font-bold">
//                     {course.price > 0 ? `₹${course.price}` : "Free"}
//                   </p>
//                 </CardHeader>

//                 <CardContent className="space-y-4">

//                   <Button
//                     size="lg"
//                     className="w-full"
//                     onClick={handleCourseAction}
//                     disabled={enrolling}
//                   >
//                     {enrolling ? "Processing..." : buttonText}
//                   </Button>

//                   {isEnrolled && (
//                     <>
//                       <Progress value={progressPercent} className="h-2" />
//                       <p className="text-sm text-muted-foreground">
//                         {progressPercent}% completed
//                       </p>
//                     </>
//                   )}

//                   <Separator />

//                   <div className="space-y-3 text-sm">

//                     <div className="flex items-center gap-2">
//                       <Clock className="h-4 w-4" /> {course.duration || "N/A"}
//                     </div>

//                     <div className="flex items-center gap-2">
//                       <BarChart className="h-4 w-4" /> {course.level}
//                     </div>

//                     <div className="flex items-center gap-2">
//                       <ListVideo className="h-4 w-4" />
//                       {course.lessons?.length || 0} Lessons
//                     </div>

//                     <div className="flex items-center gap-2">
//                       <Languages className="h-4 w-4" /> {course.language}
//                     </div>

//                     <div className="flex items-center gap-2">
//                       <GraduationCap className="h-4 w-4" />
//                       {course.certificate ? "Certificate Included" : "No Certificate"}
//                     </div>

//                   </div>
//                 </CardContent>
//               </Card>
//             </div>
//           </aside>
//         </div>
//       </div>
//     </div>
//   );
// } 



"use client";

import { useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { toast } from "sonner";
import DOMPurify from "dompurify";
import parse from "html-react-parser";

import {
  useGetCourseBySlugQuery,
  useGetCourseProgressQuery,
  useEnrollCourseMutation,
} from "@/features/api/courseApi";

import { useGetOrdersQuery } from "@/features/api/paymentApi";

import {
  Clock,
  BarChart,
  Languages,
  ListVideo,
  ChevronRight,
  Video,
  GraduationCap,
} from "lucide-react";

import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Separator } from "@/components/ui/separator";
import { Skeleton } from "@/components/ui/skeleton";
import { Progress } from "@/components/ui/progress";

import {
  Breadcrumb,
  BreadcrumbLink,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

export default function CourseDetailPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const user = useSelector((s) => s.auth.user);

  /* ---------------- FETCH COURSE ---------------- */
  const { data, isLoading, error, refetch } = useGetCourseBySlugQuery(slug);
  const course = data?.course;

  /* ------------- FETCH USER PROGRESS -------------- */
  const { data: progressData } = useGetCourseProgressQuery(course?._id, {
    skip: !user || !course?._id,
  });

  /* ------------- FETCH ORDERS (PAID) -------------- */
  const { data: ordersData } = useGetOrdersQuery(
    { search: user?.email },
    { skip: !user }
  );

  const [enrollCourse, { isLoading: enrolling }] =
    useEnrollCourseMutation();

  /* ------------- CLEAN MEDIA PATHS -------------- */
  const media = (url) =>
    url?.startsWith("/uploads") ? `https://fetc.in${url}` : url || "";

  /* ---------------- ERROR HANDLING ---------------- */
  useEffect(() => {
    if (error) toast.error("Failed to load course");
  }, [error]);

  /* ----------- AUTO-REFRESH EVERY 30 SEC ---------- */
  useEffect(() => {
    const t = setInterval(() => refetch?.(), 30000);
    return () => clearInterval(t);
  }, [refetch]);

  /* ------------- LOADING UI (BEST) -------------- */
  if (isLoading || !course) {
    return (
      <div className="container px-4 py-12 mx-auto">
        <Skeleton className="h-72 rounded-xl w-full" />
        <Skeleton className="h-6 w-2/5 mt-6" />
        <Skeleton className="h-4 w-1/2 mt-2" />
      </div>
    );
  }

  /* ------------- UNPUBLISHED CHECK -------------- */
  const isCreator = user?._id === course?.creator;
  if (course.status !== "published" && !isCreator) {
    return (
      <div className="container px-4 py-16">
        <Card>
          <CardHeader>
            <CardTitle>Course Unavailable</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="mb-4">
              This course is not published yet.
            </p>
            <Button onClick={() => navigate("/")}>Go Home</Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  /* ---------------- ENROLLMENT LOGIC ---------------- */
  const courseId = String(course._id);

  const viaProfile =
    user?.enrolledCourses?.map(String).includes(courseId);

  const viaOrder =
    !!ordersData?.data?.some(
      (o) =>
        (String(o.courseId) === courseId ||
          String(o.productId) === courseId) &&
        o.status === "SUCCESS" &&
        (o.email === user?.email ||
          o.customerEmail === user?.email)
    );

  const isEnrolled = viaProfile || viaOrder;

  /* ---------------- BUTTON TEXT ---------------- */
  let buttonText =
    course.price > 0 ? `Buy Now ₹${course.price}` : "Enroll for Free";

  if (isEnrolled) {
    buttonText =
      progressData?.percentage > 0
        ? "Continue Learning"
        : "Start Course";
  }

  /* ---------------- ENROLL HANDLER ---------------- */
  const handleCTA = () => {
    if (!user) return navigate("/login");

    if (isEnrolled) {
      return navigate(`/courses/${course.slug}/learn`);
    }

    // First time → always redirect to checkout
    const q = new URLSearchParams({
      courseId: course._id,
      price: course.price ?? 0,
      courseName: course.title || "",
      courseImage: media(course.featuredImage),
      productType: "COURSE",
    });

    navigate(`/checkout?${q}`);
  };

  /* ---------------- INSTRUCTOR INITIALS ---------------- */
  const instructorInit =
    (course.instructorName || "IN")
      .split(" ")
      .map((s) => s[0])
      .join("")
      .toUpperCase();

  /* ---------------- SAFE HTML ---------------- */
  const cleanHtml = parse(DOMPurify.sanitize(course.content || ""));

  /* ---------------- UI START ---------------- */
  return (
    <div className="bg-gray-50 min-h-screen">
      <Helmet>
        <title>{course.title}</title>
        <meta
          name="description"
          content={course.metaDescription || ""}
        />
      </Helmet>

      <div className="container px-4 py-10 mx-auto">
        {/* ---------------- BREADCRUMB ---------------- */}
        <Breadcrumb className="mb-6">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/">Home</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/courses">Courses</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>{course.title}</BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <div className="grid lg:grid-cols-3 gap-10">
          {/* ---------------- LEFT COLUMN ---------------- */}
          <div className="lg:col-span-2 space-y-8">
            {/* -------- TITLE -------- */}
            <h1 className="text-4xl font-bold">{course.title}</h1>
            <p className="text-gray-600">{course.metaDescription}</p>

            {/* -------- Instructor Small Card -------- */}
            <div className="flex items-center gap-4">
              <Avatar>
                {course.instructorImage ? (
                  <AvatarImage src={media(course.instructorImage)} />
                ) : (
                  <AvatarFallback>{instructorInit}</AvatarFallback>
                )}
              </Avatar>
              <div>
                <div className="font-medium">
                  {course.instructorName}
                </div>
                <div className="text-sm text-gray-500">
                  {course.instructorBio}
                </div>
              </div>
            </div>

            {/* -------- MEDIA PREVIEW -------- */}
            <div className="rounded-xl overflow-hidden shadow">
              {course.videoUrl ? (
                <video
                  controls
                  src={media(course.videoUrl)}
                  className="w-full h-[420px] object-cover bg-black"
                />
              ) : (
                <img
                  src={media(course.featuredImage)}
                  alt={course.title}
                  className="w-full h-[420px] object-cover"
                />
              )}
            </div>

            {/* -------- What You Will Learn -------- */}
            <Card>
              <CardHeader>
                <CardTitle>What You Will Learn</CardTitle>
              </CardHeader>
              <CardContent>
                {Array.isArray(course.learningOutcomes) &&
                course.learningOutcomes.length ? (
                  <ul className="list-disc pl-6 space-y-1">
                    {course.learningOutcomes.map((o, i) => (
                      <li key={i}>{o}</li>
                    ))}
                  </ul>
                ) : (
                  <p>No learning outcomes added.</p>
                )}
              </CardContent>
            </Card>

            {/* -------- Lessons List -------- */}
            <Card>
              <CardHeader>
                <CardTitle>Lessons</CardTitle>
              </CardHeader>
              <CardContent className="space-y-3">
                {(course.lessons || []).map((lesson, idx) => (
                  <div
                    key={lesson._id}
                    className="flex justify-between items-center p-3 border rounded-md hover:bg-gray-100"
                  >
                    <div className="flex items-center gap-4">
                      <span className="h-8 w-8 bg-blue-100 text-blue-700 rounded-full flex items-center justify-center">
                        {idx + 1}
                      </span>
                      <span>{lesson.title}</span>
                    </div>
                    <ChevronRight className="text-gray-400" />
                  </div>
                ))}
              </CardContent>
            </Card>

            {/* -------- About Section -------- */}
            <Card>
              <CardHeader>
                <CardTitle>About This Course</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="prose max-w-none">{cleanHtml}</div>
              </CardContent>
            </Card>

            {/* -------- FAQs -------- */}
            {course.faqs?.length > 0 && (
              <Card>
                <CardHeader>
                  <CardTitle>FAQs</CardTitle>
                </CardHeader>
                <CardContent className="space-y-3">
                  {course.faqs.map((f, i) => (
                    <div key={i}>
                      <div className="font-semibold">{f.question}</div>
                      <div className="text-sm text-gray-600">
                        {f.answer}
                      </div>
                    </div>
                  ))}
                </CardContent>
              </Card>
            )}
          </div>

          {/* ---------------- RIGHT SIDEBAR ---------------- */}
          <aside className="sticky top-8 space-y-6">
            <Card>
              <CardHeader>
                <div>
                  <div className="text-4xl font-bold">
                    {course.price > 0 ? `₹${course.price}` : "Free"}
                  </div>
                  <p className="text-gray-500 text-sm mt-1">
                    {course.level} • {course.language}
                  </p>
                </div>
              </CardHeader>

              <CardContent>
                <Button
                  size="lg"
                  className="w-full"
                  onClick={handleCTA}
                  disabled={enrolling}
                >
                  {buttonText}
                </Button>

                {isEnrolled && (
                  <div className="mt-4">
                    <Progress
                      value={progressData?.percentage || 0}
                      className="h-2"
                    />
                    <p className="text-sm text-gray-500 mt-2">
                      {progressData?.percentage || 0}% completed
                    </p>
                  </div>
                )}

                <Separator className="my-4" />

                {/* ---- Only Sidebar Shows Course Details ---- */}
                <div className="space-y-3 text-sm">

                  <div className="flex justify-between">
                    <span className="flex items-center gap-2">
                      <Clock className="w-4" /> Duration
                    </span>
                    <span>{course.duration || "N/A"}</span>
                  </div>

                  <div className="flex justify-between">
                    <span className="flex items-center gap-2">
                      <ListVideo className="w-4" /> Lessons
                    </span>
                    <span>{course.lessons?.length || 0}</span>
                  </div>

                  <div className="flex justify-between">
                    <span className="flex items-center gap-2">
                      <GraduationCap className="w-4" /> Certificate
                    </span>
                    <span>{course.certificate ? "Yes" : "No"}</span>
                  </div>

                  <div className="flex justify-between">
                    <span className="flex items-center gap-2">
                      <Languages className="w-4" /> Language
                    </span>
                    <span>{course.language}</span>
                  </div>

                  <div className="flex justify-between">
                    <span>Published</span>
                    <span>
                      {course.publishedAt
                        ? new Date(
                            course.publishedAt
                          ).toLocaleDateString()
                        : "—"}
                    </span>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* ---- Instructor Card ---- */}
            <Card>
              <CardHeader>
                <CardTitle>Instructor</CardTitle>
              </CardHeader>
              <CardContent className="flex items-center gap-4">
                <Avatar>
                  {course.instructorImage ? (
                    <AvatarImage src={media(course.instructorImage)} />
                  ) : (
                    <AvatarFallback>{instructorInit}</AvatarFallback>
                  )}
                </Avatar>
                <div>
                  <div className="font-medium">
                    {course.instructorName}
                  </div>
                  <div className="text-sm text-gray-500">
                    {course.instructorBio}
                  </div>
                </div>
              </CardContent>
            </Card>
          </aside>
        </div>
      </div>
    </div>
  );
}
